<script>
export default {
  methods: {
    logoutImpersonation() {
      this.$store.dispatch('logoutImpersonation');
    },
  },
};
</script>

<template lang='pug'>
button.impersonation(@click='logoutImpersonation') END SESSION
</template>

<style>
@import '~import/index';

.impersonation {
  background-color: $errorColor;
  position: fixed;
  transform: rotate(-90deg);
  top: 15rem;
  right: -43px;
  z-index: 2147483647;

  &:hover,
  &:focus {
    background-color: darken($errorColor, 10%);
  }
}
</style>